export const WEB_ROUTES = {
  APPLICATION_REJECTED: 'application-rejected',
  APPLICATION_APPLY: 'application-apply',
  APPLICATION_ACCEPTED: 'application-accepted',
  APPLICATION_LOADING: 'application-loading',
  APPLICATION_CHANGE_IBAN: 'application-change-iban',
  APPLICATION_OFFER: 'application-offer',
  APPLICATION_OFFER_INCREASE: 'application-offer-increase',
  REGISTRATION_STEP_1: 'registration-step1',
  REGISTRATION_STEP_2: 'registration-step2',
  REGISTRATION_STEP_3: 'registration-step3',
  REGISTRATION_STEP_4: 'registration-step4',
  REGISTRATION_UPLOAD: 'registration-upload',
  PROFILE: 'profile',
  PROFILE_EDIT: 'profile-edit',
  PROFILE_MY_LOAN: 'profile-my-loan',
  PROFILE_NO_LOAN: 'profile-no-loan',
  PROFILE_LEGAL_DOCUMENTS: 'profile-legal-documents',
  PROFILE_CHANGE_PASSWORD: 'profile-change-password',
  PROCESSING_VERIFY_CARD: 'profile-add-card',
  MY_PROFILE: 'profile-my-profile',
  LOGIN: 'login',
  MAIN: 'index',
  HOW_TO_GET: 'loan',
  HOW_TO_PAY: 'repay',
  DOCUMENTS: 'documents',
  OFFICES: 'offices',
  FAQ: 'faq',
  RECOVER: 'recover',
  CONTACT: 'contact',
  IBAN: 'iban',
  ABOUT: 'about',
  BIOMETRY: 'biometry',
  BIOMETRY_REJECTED: 'biometry-rejected',
  BIOMETRY_LOADING: 'biometry-loading',
};

export const DISPATCH_API = {
  UPDATE_MOBILE: 'client/changePhone',
  UPDATE_EMAIL: 'client/changeEmail',
  SEND_SMS: 'client/sendSms',
  SEND_EMAIL_CODE: 'client/sendEmail',
  CLIENT_RECOVER: 'client/recover',
  CLIENT_CREATE: 'client/create',
  CLIENT_UPDATE: 'client/update',
  CLIENT_GET_LOAN: 'client/getLoan',
  CLIENT_ADD_CONTACT: 'client/addContact',
  CLIENT_CAPTURE_BEHAVIOUR: 'client/captureBehaviour',
  COMPLETE_STEP_TWO: 'client/completeStepTwo',
  COMPLETE_STEP_THREE: 'client/completeStepThree',
  COMPLETE_STEP_FOUR: 'client/completeStepFour',
  UPDATE_CLIENT_INFO: 'client/completeStepFour',
  CLIENT_CREATE_APPLICATION: 'client/createApplication',
  CLIENT_GET_APPLICATION: 'client/getApplication',
  UPDATE_IBAN: 'http/updateIban',
  VERIFY_IBAN: 'client/verifyIban',
  GET_REGIONS: 'geo/getRegions',
  GET_PERSONAL_DATA_PROCESSING_CONSENT: 'http/getPersonalDataConsent',
  SEND_PRIVATE_SMS: 'client/sendPrivateSms',
  VERIFY_PRIVATE_SMS: 'client/verifyPrivateSms',
  PAYMENT_METHOD: 'http/paymentMethod',
  CLIENT_GET_PAYMENT_SCHEDULE: 'client/getActivePaymentSchedule',
};
